/*
 * THIS IS A WORKAROUND. This fixes the stupid angular material datepicker
 * including a time in the date. Replace this with the useUtc option
 * once we have a version with this fix (looks like it's 6.3+).
 * https://github.com/angular/material2/issues/7167
*/

import { Inject, Injectable, Optional } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import * as moment from 'moment';
import { Moment } from 'moment';

@Injectable({
    providedIn: 'root'
})
export class MomentUtcDateAdapter extends MomentDateAdapter {

    constructor(@Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string) {
        super(dateLocale);
    }

    createDate(year: number, month: number, date: number): Moment {
        // Moment.js will create an invalid date if any of the components are out of bounds, but we
        // explicitly check each case so we can throw more descriptive errors.
        if (month < 0 || month > 11) {
            throw Error(`Invalid month index "${month}". Month index has to be between 0 and 11.`);
        }

        if (date < 1) {
            throw Error(`Invalid date "${date}". Date has to be greater than 0.`);
        }

        let result = moment.utc({ year, month, date }).locale(this.locale);

        // If the result isn't valid, the date must have been out of bounds for this month.
        if (!result.isValid()) {
            throw Error(`Invalid date "${date}" for month with index "${month}".`);
        }

        return result;
    }

    parse(value: any, parseFormat: string | string[]): Moment | null {
        if (value && typeof value == 'string') {
            return moment.utc(value, parseFormat).locale(this.locale);
        }
        return value ? moment.utc(value).locale(this.locale) : null;
    }

    today(): Moment {
        return moment.utc().locale(this.locale);
    }

    deserialize(value: any): Moment | null {
        let date;
        if (value instanceof Date) {
            date = moment(value);
        }
        if (typeof value === 'string') {
            if (!value) {
                return null;
            }
            date = moment.utc(value, moment.ISO_8601).locale(this.locale);
        }
        if (date && this.isValid(date)) {
            return date;
        }
        return super.deserialize(value);
    }
}
